if ('customElements' in window && !customElements.get('quick-actions')) {
  customElements.define(
    'quick-actions',
    class QuickActions extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.footer = document.querySelector('.site-footer');
        this.events = new AbortController();
        this.onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { signal: this.events.signal, passive: true });

        if (this.footer && 'IntersectionObserver' in window) {
          this.footerObserver = new IntersectionObserver(([entry]) => {
            this.footerInView = entry.isIntersecting;
            this.apply();
          });
          this.footerObserver.observe(this.footer);
        }
        this.onScroll();
      }

      disconnectedCallback() {
        this.events?.abort();
        this.events = null;
        this.footerObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      onScroll() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          const next = window.scrollY > window.innerHeight * 0.6;
          if (next === this.pastFirstScreen) return;
          this.pastFirstScreen = next;
          this.apply();
        });
      }

      apply() {
        this.classList.toggle('is-visible', Boolean(this.pastFirstScreen && !this.footerInView));
      }
    }
  );
}
